export default __webpack_public_path__ + "static/media/gallery-title.3d0b7a4c.png";